/**
 * <pdp-live-viewer>
 * Renders a fake-live visitor count that drifts within [min, max].
 * SessionStorage-backed per product handle so refreshes feel stable.
 *
 * Expects data attributes:
 *   data-min       integer (floor)
 *   data-max       integer (ceiling)
 *   data-reseed    reseed interval in seconds
 *
 * Updates the textContent of [data-count].
 */
if (!customElements.get('pdp-live-viewer')) {
  customElements.define(
    'pdp-live-viewer',
    class PdpLiveViewer extends HTMLElement {
      constructor() {
        super();
        this.countEl = this.querySelector('[data-count]');
        this.min = Number(this.dataset.min) || 10;
        this.max = Number(this.dataset.max) || 40;
        if (this.max <= this.min) this.max = this.min + 5;
        this.reseedMs = (Number(this.dataset.reseed) || 30) * 1000;
        this.storageKey = 'pdp-live-' + (window.location.pathname || 'default');
        this.timerId = null;
      }

      connectedCallback() {
        const stored = this.readStored();
        const initial = stored !== null ? stored : this.randomInRange();
        this.setCount(initial);
        this.timerId = window.setInterval(() => this.drift(), this.reseedMs);
      }

      disconnectedCallback() {
        if (this.timerId !== null) {
          window.clearInterval(this.timerId);
          this.timerId = null;
        }
      }

      randomInRange() {
        return Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
      }

      drift() {
        const current = Number(this.countEl?.textContent) || this.randomInRange();
        const delta = Math.random() < 0.5 ? -1 : 1;
        const step = delta * (1 + Math.floor(Math.random() * 2));
        let next = current + step;
        if (next < this.min) next = this.min + Math.floor(Math.random() * 2);
        if (next > this.max) next = this.max - Math.floor(Math.random() * 2);
        this.setCount(next);
      }

      setCount(value) {
        if (!this.countEl) return;
        this.countEl.textContent = String(value);
        this.writeStored(value);
      }

      readStored() {
        try {
          const raw = window.sessionStorage.getItem(this.storageKey);
          return raw === null ? null : Number(raw);
        } catch {
          return null;
        }
      }

      writeStored(value) {
        try {
          window.sessionStorage.setItem(this.storageKey, String(value));
        } catch {
          /* sessionStorage unavailable - silently skip persistence */
        }
      }
    }
  );
}
